/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Header, Segment, Grid } from 'semantic-ui-react'

class PayingCustomer extends React.PureComponent {
  state = {
    payingCustomers: [],
    customerOrders: {},
  }

  componentDidMount() {
    const { orders } = this.props

    this.getPayingCustomer(orders)
  }

  componentWillReceiveProps(nextProps) {
    const { orders } = this.props

    if (nextProps.order !== orders) {
      this.getPayingCustomer(nextProps.orders)
    }
  }

  getPayingCustomer = orders => {
    let payingCustomers = []
    const customerOrders = {}

    _.map(orders, (order, orderKey) => {
      if (order.status === 'delivered') {
        payingCustomers.push(order.deliveree)

        customerOrders[order.deliveree] = {
          ...customerOrders[order.deliveree],
          [orderKey]: order,
        }
      }
    })

    payingCustomers = _.uniq(payingCustomers)

    this.setState({ payingCustomers, customerOrders })
  }

  render() {
    const { payingCustomers, customerOrders } = this.state
    const avgPerCustomer = _.mean(_.map(customerOrders, orders => _.size(orders)))

    return (
      <Segment>
        <Header size="large">Paying Customer</Header>
        <Grid columns="equal" style={{ marginTop: 10 }}>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total Paying Customers</Header>
              <Header size="medium">{_.size(payingCustomers)}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Customer orders (AVG)</Header>
              <Header size="medium">{Number(avgPerCustomer || 0).toFixed(2)}</Header>
            </Segment>
          </Grid.Column>
        </Grid>
      </Segment>
    )
  }
}

const mapStateToProps = ({ dashboard }) => ({
  orders: dashboard.dashboardOrders,
})

export default connect(mapStateToProps)(PayingCustomer)



// WEBPACK FOOTER //
// ./src/components/Dashboard/PayingCustomer.js